export const linkyDefaults = {
  phone: false,
  email: false,
  className: 'logtime__linky-link',
  truncate: 32,
};
